import React, { useState, useEffect } from "react"

import "./article-test-response.scss"
import Button from "../../../shared/components/atoms/button/button"

const ArticleTestResponse = ({ handleBackText, dataResponse, mobile }) => {
  const [pageLoad, setPageLoad] = useState(false)

  useEffect(() => {
    window.scroll(0, 400)
    setPageLoad(true)
  }, [])

  return (
    <div className="f-article-response">
      <div className="f-article-response-content">
        <p className="f-article-response-content-copyResult">¡Tu resultado!</p>
        <img
          alt={dataResponse.imagenDeLaRespuesta[0].description}
          src={
            mobile
              ? dataResponse.imagenDeLaRespuesta[1].file.url
              : pageLoad
              ? dataResponse.imagenDeLaRespuesta[0].file.url
              : dataResponse.imagenDeLaRespuesta[0].fixed.base64
          }
        />

        <div className="f-article-response-content-text">
          <h4>{dataResponse.tituloDeRespuesta}</h4>
          <p>
            {dataResponse.descripcionDeLaRespuesta.descripcionDeLaRespuesta}
          </p>
        </div>
      </div>
      <div className="f-article-test-send-answer" onClick={handleBackText}>
        <Button className="secondary-pink" title="Volver a tomar test" />
      </div>
    </div>
  )
}

export default ArticleTestResponse
